import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { formFocusNextKeyboard } from 'shouldve-been-react';
import { ErrorMessage, QuickTextInput } from 'shouldve-been-mui';

class MaskChecklistElement extends ChecklistElement {

    private _regexMask: string;

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, regexMask: string) {

        super(elementId, name, itemNumber, sortNumber, EditorType.MASK);
        this._regexMask = regexMask;
    }

    public get regexMask(): string {
        return this._regexMask;
    }

    public set regexMask(value: string) {
        this._regexMask = value;
    }

    public buildFormElement(value: string, onBlur: (value: string) => Promise<void>, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <QuickTextInput
                    value={value}
                    onBlur={onBlur}
                    variant='outlined'
                    dense={true}
                    minWidth={Math.min(screenWidth * 0.8, 500)}
                    maxWidth={Math.min(screenWidth * 0.8, 500)}
                    labelText={this.name}
                    height='40px'
                    onKeyDown={formFocusNextKeyboard}
                />
                {value !== '' && !(new RegExp('^' + this.regexMask + '$', 'u')).test(value)
                    ? (
                        <ErrorMessage
                            message={'Invalid pattern'}
                            maxWidth={Math.min(screenWidth * 0.8, 500)}
                        />
                    )
                    :   (
                        <>
                            <br />
                            <br />
                        </>
                    )
                }
            </React.Fragment>
        );
    }
}

export default MaskChecklistElement;